const zhCN = {
  hero: {
    title: "去看更宽广的世界",
    subtitle: "流畅 4K｜不限流量｜三网优化｜AI 优化",
    free_register: "免费注册",
  },
  nav: {
    home: "首页",
    login: "登录",
    signup: "注册",
    pricing: "价格",
    faq: "常见问题",
    contact: "联系我们",
    wechat: "微信客服",
    telegram: "Telegram 电报",
    email: "电子邮件",
    download: "下载客户端",
    android: "安卓",
    smarttv: "智能电视",
    userCenter: "用户中心",
    logout: "退出登录",
    logoutConfirm: "确定要退出当前账号吗？",
  },
  common: {
    cancel: "取消",
    loading: "处理中…",
    backToHome: "用户中心",
    close: "关闭",
  },
  wechatModal: {
    title: "客服微信",
    loadError: "暂时无法加载微信二维码, 请稍后重试",
    description: "扫描二维码添加客服, 或搜索下方微信号",
  },
  features: {
    title: "为什么选择梯子Z",
    subtitle:
      "稳定高速, 不限流量, 全球覆盖, 自研客户端, AI应用优化, 智能分流, 专业客服 - 一站式加速体验",
    moreLink: "了解更多",
    items: {
      1: {
        title: "流畅 4K｜不限流量",
        desc: "油管任意拖拽, Netflix 奈飞高清即点即播。不限流量，想看多久就看多久",
      },
      2: {
        title: "法国正规企业",
        desc: "注册于法国巴黎，严格遵守欧盟数据法规，让每位用户的隐私更安心",
      },
      3: {
        title: "自研客户端｜全平台支持",
        desc: "自研客户端覆盖主流平台，并避免线路与配置信息泄漏，更安全安心",
      },
      4: {
        title: "智能分流｜AI 专属优化",
        desc: "国内外网站自动分流，访问不受影响。香港线路也可流畅使用各类 AI 应用",
      },
      5: {
        title: "专业客服支持",
        desc: "提供微信, 邮箱等多渠道实时协助，遇到问题随时都能找到我们",
      },
      6: {
        title: "全球高速服务器",
        desc: "香港, 美国, 东南亚, 欧洲, 澳洲, 非洲, 南美等多地区节点自由选择",
      },
    },
  },
  pricing: {
    sectionTitle: "套餐价格",
    sectionSubtitle: "根据使用时长选择最适合你的套餐，所有套餐均包含完整功能, 不限流量和客服支持",
    labels: {
      perMonth: "月",
      recommended: "推荐",
      savePercent: "立省 {{rate}}%",
      defaultCta: "立即开通",
      cta: {
        open: "立即开通",
        toUserCenter: "查看我的套餐",
        renew: "立即续费",
        reopen: "重新开通",
      },
    },
    features: {
      bandwidth: "4K/1080P高清流媒体带宽",
      multiDevice: "支持自用多台设备同时使用",
      noShare: "禁止共享账号给其他人",
      streamingUnlock: "部分服务器解锁流媒体",
    },
    paymentModal: {
      title: "选择支付方式 - {{plan}}",
      paymentTitle: "选择支付方式",
      methods: {
        alipay: "支付宝支付",
        alipayDesc: "使用支付宝扫码或在手机支付宝中完成支付",
        wechat: "微信支付",
        wechatDesc: "使用微信扫码完成支付，支持钱包余额与绑定银行卡",
        card: "信用卡 / 借记卡支付",
        cardDesc: "支持 Visa / MasterCard / 银联卡，并可通过 Apple Pay 与 Link 完成支付",
      },
      noticeActive:
        "续费说明：本次续费会在您当前的到期时间基础上顺延，不会浪费剩余有效期。例如：如果当前到期日为 2025-12-31，续费成功后将在此日期基础上再延长对应天数",
      noticeExpired:
        "开通说明：您的套餐目前已到期，本次支付成功后，有效期将从付款成功当天开始重新计算",
      noticeNew:
        "开通说明：本次为首次开通，套餐有效期将从付款成功当天开始计算；后续续费时会在当时剩余有效期基础上顺延，不会浪费时间",
      notice:
        "支付成功后，系统会在 1 分钟内自动为你开通或续费套餐。如遇到问题可以通过微信或邮箱联系客服",
      confirm: "支付",
    },
    priceNote1: "套餐以欧元计价，支付宝 / 微信 / 银联支付会自动换算成人民币",
    priceNote2: "信用卡支付也会自动换算为本地币种，无需欧元账户",
    priceNote3: "部分支付渠道会收取约 3%–7% 的额外手续费（由支付平台收取）",
    plans: {
      monthly: {
        tag: "",
        title: "月套餐",
        duration: "1 个月",
        discount: "6 折优惠",
        cta: "立即开通",
        features: {
          1: "无限流量使用",
          2: "支持多台设备同时在线",
          3: "禁止恶意分享账号",
          4: "4K / 1080P 视频无压力",
          5: "客服支持（微信 / 邮件）",
        },
      },
      yearly: {
        tag: "最受欢迎",
        title: "年套餐",
        duration: "1 年",
        discount: "4 折优惠",
        cta: "推荐购买",
        features: {
          1: "无限流量使用",
          2: "支持多台设备同时在线",
          3: "4K 视频流畅播放",
          4: "AI 应用专属线路优化",
          5: "微信一对一技术支持",
        },
      },
      halfyear: {
        tag: "",
        title: "半年套餐",
        duration: "6 个月",
        discount: "5.2 折优惠",
        cta: "立即开通",
        features: {
          1: "无限流量使用",
          2: "支持多台设备同时在线",
          3: "4K / 1080P 视频无压力",
          4: "全球节点自由切换",
          5: "客服支持（微信 / 邮件）",
        },
      },
    },
  },
  faq: {
    title: "常见问题",
  },
  payments: {
    title: "购买套餐",
    subtitle: "请选择支付方式和支付通道并完成付款",
    loading: "正在进入支付页面…",
    noPaymentAction: "该支付通道未返回二维码或跳转链接，暂时无法继续支付，请尝试切换其他支付通道。",
    alipay: {
      scan: "请使用支付宝扫码支付",
    },
    wechat: {
      scan: "请使用微信扫码支付",
    },
    qr: {
      tip: "支付完成后请不要关闭此页面，我们会自动检测支付状态。",
      open: "打开支付页面",
    },
    card: {
      enter: "请输入银行卡信息",
      loading: "正在加载支付组件…",
      pay: "确认付款",
      tip: "如需验证（3D Secure），将自动弹出/跳转完成验证。",
    },
    polling: "正在检测支付状态（每 10 秒刷新一次）",
    pollingInit: "正在获取支付状态…",
    pollingStatus: "当前状态",
    pollingError: "状态检查失败",
    refresh: {
      title: "正在检测支付状态（每 10 秒刷新一次）",
      init: "正在获取支付状态…",
      status: "当前支付状态：{{status}}",
      errorPrefix: "状态检查失败",
    },
    successTitle: "支付成功",
    successDesc: "我们已确认付款并完成套餐有效期更新。点击继续返回用户中心。",
    continueToUserinfo: "继续",
    errors: {
      missingShopPk: "缺少套餐信息（shop_pk）",
      missingStripePublicKeyForCheckout: "缺少 Stripe 公钥，无法发起 Checkout 支付",
      missingCheckoutSessionId: "缺少 Checkout 会话信息，无法继续支付",
      stripeJsNotAvailable: "Stripe.js 未加载，无法继续支付",
      redirectToCheckoutFailed: "跳转到 Stripe Checkout 失败",
      paymentRequestFailed: "支付请求失败，请稍后重试",
    },
    payOptions: {
      // Basic summary labels (PayOptions page)
      duration: "时长",
      total: "应付金额",
      methodTitle: "1. 请选择支付方式",
      providerTitle: "2. 请选择支付通道",
      processing: "处理中…",
      retry: "重试",
    },
    methods: {
      wechat: "微信支付",
      alipay: "支付宝",
      alipayhk: "香港支付宝",
      card: "银联卡/信用卡/借记卡",
    },
    providers: {
      stripeRecommended: "通道一 推荐",
      airwallex: "通道二",
      epay: "备用通道 - 多渠道轮换, 如果支付失败可刷新再试",
    },
    notes: {
      wechatNoScreenshotForStripeAirwallex:
        "不支持截图扫码: 须将二维码发送到另一台设备（智能手表也可以），用微信直接扫码",
      wechatEpayScreenshotAllowed: "支持截图扫码: 可将二维码截图, 通过微信扫描相册支付",
      unionpayNoExpiryCvcHint: "银联卡如未印刷有效期或安全码（CVC）, 可填写有效期12/30，CVC 000",
      currencyConversion:
        "套餐以欧元计价，支付宝 / 微信 / 银联支付将自动换算成人民币；信用卡支付也会自动换算为本地币种，无需欧元账户",
    },
    cardChannels: {
      stripeIntent: "Strip 安全支付 - 推荐; 直接输入银行卡信息支付",
      stripeCheckout: "跳转 Stripe 平台支付, 支持 Apple Pay",
    },
  },
  userInfo: {
    // 顶部欢迎文案
    welcomeUser: "欢迎回来",
    welcomeGuest: "欢迎来到用户中心",
    followUs: "关注我们",
    // 套餐与下载信息
    currentPlanTitle: "当前套餐",
    planActiveUntil: "当前套餐有效期至 {{date}}",
    planInactive: "当前暂无已开通的套餐",
    // 当前套餐有效期展示文案（InfoCard 使用）
    planExpire: "当前套餐有效期 - {{date}}",
    planExpireExpired: "当前套餐有效期 - {{date}}（已过期）",
    planCta: {
      open: "立即开通套餐",
      reopen: "重新开通套餐",
      renew: "续费延长有效期",
    },
    viewPlans: "购买套餐或续费",
    downloadClientTitle: "下载客户端",
    downloadClientDescription: "系统检测到你正在使用 {{os}}，",
    downloadClientLinkLabel: "点击去下载",
    downloadOtherClientsLabel: "查看全部应用",
    os: {
      windows: "Windows 设备",
      macos: "macOS 设备",
      android: "Android 设备",
      ios: "iOS 设备",
      linux: "Linux 设备",
      unknown: "当前设备",
    },
    verifyEmail: "确认邮箱",
    confirmEmail: {
      sending: "发送中…",
      submitError: "确认邮件发送失败，请稍后重试",
      success: "确认邮件已发送，请查看邮箱",
    },
    devices: {
      title: "已连接设备",
      loading: "正在获取设备...",
      empty: "暂无已连接客户端设备",
      fetchError: "设备信息获取失败，请稍后重试",
      unknownDevice: "未知设备",
      unknownVersion: "未知版本",
      summaryWithLatest: "{{count}}/{{limit}} 台设备，最近：{{device}} · {{version}}",
      manage: "管理",
      disconnect: "断开",
      disconnecting: "断开中...",
      disconnectError: "断开设备失败，请稍后重试",
      modalTitle: "管理已连接设备",
      modalSummary: "当前 {{count}}/{{limit}} 台设备保持连接",
      lastSeen: "最近在线 {{time}}",
      expiresAt: "登录有效期至 {{time}}",
    },
    changePassword: "修改密码",
    passwordModal: {
      title: "修改密码",
      oldPassword: "当前密码",
      newPassword: "新密码",
      confirmPassword: "确认新密码",
      cancel: "取消",
      submit: "确认修改",
      submitting: "修改中…",
      missingFields: "请填写当前密码、新密码和确认新密码",
      passwordMismatch: "两次输入的新密码不一致",
      submitError: "修改密码失败，请稍后重试",
      success: "密码已修改，请重新登录",
    },
    appleId: "Apple ID",
    thirdPartyLinks: "订阅链接",
    subscriptionModal: {
      title: "订阅链接",
      description:
        "订阅链接仅限本人使用，严禁分享。一旦系统检测到分享行为，账号将被立即停用且无法解封。",
      clashDescription: "【占位】这里是 Clash 链接说明文案，请按需替换。",
      loading: "正在获取订阅链接...",
      fetchError: "获取订阅链接失败，请稍后重试",
      copyError: "复制失败，请手动复制",
      retry: "重试",
      copyButton: "复制链接",
      copied: "已复制",
      tabs: {
        subscription: "订阅链接",
        clash: "Clash",
      },
      compatibleApps: {
        subscription: "适用于 Shadowrocket, V2rayNG Android, V2rayN Windows & macOS",
        clash: "适用于 Clash, OpenClash；在浏览器里打开链接，可直接下载 YAML 配置",
      },
      primaryLabel: "主订阅链接",
      backupLabel: "备用订阅链接",
      hoverToReveal: "鼠标悬停此处显示订阅链接",
      hoverHint: "安全提示：离开该区域后将自动隐藏链接内容",
    },
    appList: {
      title: "全部应用",
      subtitle:
        "我们提供自研客户端覆盖主流平台，同时也支持常见的第三方应用，方便你在各种设备上使用 ZionLadder",
      downloadLink: "前往下载",
      setupLink: "前往设置",
      comingSoon: "即将发布",
      ios: {
        title: "苹果 iOS",
        description: "支持iPhone, iPad 和 M系列芯片 Mac",
      },
      macos: {
        title: "苹果 macOS",
        description: "支持 macOS 10.15+ 的 Intel 芯片 Mac 和 macOS 11+ 的 M系列芯片 Mac",
      },
      android: {
        title: "安卓 Android",
        description: "支持大多数 Android 手机, 平板和电脑, 华为鸿蒙系统的卓易通和出境易",
      },
      windows: {
        title: "Windows",
        description: "适用于 Windows 7 x64 和 Windows 10/11+ 系统的电脑",
      },
      appletv: {
        title: "Apple TV",
        description: "适用于运行 tvOS 系统的 Apple TV 设备",
      },
      smarttv: {
        title: "智能电视（Smart TV）",
        description: "适用于安卓系统的智能电视",
      },
      openwrt: {
        title: "OpenWrt 路由器",
        description: "适用于刷入 OpenWrt 固件的路由器设备",
      },
      merlin: {
        title: "华硕梅林",
        description: "适用于 Merlin 与改版梅林固件的华硕路由器",
      },
      linux: {
        title: "Linux",
        description: "适用于常见 Linux 发行版的桌面或服务器环境",
      },
      thirdParty: {
        title: "第三方应用",
        description:
          "适用于 Shadowrocket, V2rayN, V2rayNG, Open Clash, Clash, OpenWrt, Passwall, 梅林...",
      },
    },
  },
  clients: {
    common: {
      download: "下载",
      viewDownloads: "查看下载",
      currentVersion: "当前版本",
    },
    signedDownload: {
      title: "下载客户端",
      loading: "正在准备下载...",
      started: "下载应该已经自动开始。如果没有，请点击下面的按钮手动下载。",
      fallbackHint: "这个下载链接 {{minutes}} 分钟内有效。也可以复制链接到浏览器中打开下载。",
      fetchError: "请求暂时无法处理，请稍后再试。",
      loginRequired: "请先登录后再生成下载链接。",
      forbidden: "当前账号暂无权限生成该下载链接。",
      rateLimited: "生成下载链接过于频繁，请稍后再试。",
      copyError: "复制失败，请手动复制。",
      copy: "复制链接",
      copied: "已复制",
      manualDownload: "手动下载",
    },
    ios: {
      softwareName: "iOS 客户端名称占位",
      supportedDevices: "适用设备: iPhone / iPad",
      version: "当前版本: v1.0.0",
      currentVersionLabel: "当前版本",
      getSharedAppleId: "获取共享 Apple ID",
      desc: {
        title: "使用说明",
        section1Title: "基本功能",
        section1Body:
          "1. 应用界面右上角的购买按钮可用于账号充值。\n2. 点击刷新按钮可获取最新线路列表。\n3. 点击分享按钮可将线路共享到局域网设备。\n4. 点击对话按钮可联系微信客服。\n\n分流模式对应不同的分流策略：\n1. 智能分流：按国内与国外网站分流，仅国外网站通过线路访问。\n2. 全局模式：所有流量都通过线路访问，可能影响国内应用体验。",
        section2Title: "选择线路",
        section2Body:
          "请根据你的网络环境与使用需求选择线路。右侧绿色标签会标注适合的运营商与线路类型。\n选择线路后，再点击上图中的【连接】按钮，即可通过梯子Z访问互联网。",
      },
      usage: {
        title: "使用说明",
        step1: "使用共享Apple ID登录App Store, 切换到海外商店",
        step2: "下载安装ZionLadder 梯子Z App",
        step3: "选择合适的分流方式和线路, 注意运营商匹配, 海外或港澳台建议选择直连",
        step4: "点击连接, 开始使用服务",
      },
    },
    sharedid: {
      title: "共享 Apple ID",
      titleLoginRequired: "需要登录",
      titlePaidRequired: "需要购买套餐",
      titleRenewRequired: "需要续费",
      titleNoAppleId: "暂未分配",
      titleFetchFailed: "获取失败",

      loading: "正在获取共享 Apple ID…",
      okHint: "请在 App Store 登录时使用以下账号和密码。",
      errorNetwork: "网络异常或服务器错误，请稍后再试",

      actionLogin: "去登录",
      actionBuy: "去购买套餐",
      actionRenew: "去续费",

      labelAppleId: "Apple ID",
      labelPassword: "密码",
      copied: "已复制",

      tip: "重要说明：\n1. 如果你已有外区 Apple ID，可直接使用外区 ID 下载 ZionLadder 软件，无需使用共享 Apple ID\n2. 共享 Apple ID 仅供登录 App Store 使用，登录过程中请勿绑定手机号，并请严格按照我们的图文说明操作\n3. 共享 Apple ID 仅用于下载 App 时的临时登录，下载完成后请务必退出账号，且不要用于充值或订阅其他产品；如发现违规使用，我们将立即回收该账号",
      imageHint: "请参考下方图文说明，按步骤完成操作",
      imageDesc:
        "打开 App Store（应用商店）：\n1. 点击右上角的头像\n2. 下滑屏幕到最底部，点击【退出登录】\n3. 使用共享 Apple ID 登录\n4. 在弹出菜单中，选择【不是 XXX】\n5. 输入共享 Apple ID 和密码\n6. 在 Apple 账户安全菜单中，选择【其他选项】\n7. 在弹出的“保护你的账户”窗口中，选择【不升级】\n完成共享 Apple ID 登录",
    },
    android: {
      softwareName: "Android 客户端名称占位",
      supportedDevices: "适用设备: 安卓手机 平板 电脑 | 鸿蒙卓易通 出境易",
      version: "当前版本: v1.0.0",
      currentVersionLabel: "当前版本",
      downloadApp: "下载应用",
      downloadApk: "下载 APK",
      downloadZip: "备用 ZIP",
      backupDownload: "备用下载",
      downloads: {
        arm64: {
          title: "64 位新版内核（arm64-v8a）",
          hint: "推荐大多数新款手机、平板和安卓设备使用",
        },
        armeabi: {
          title: "32 位兼容内核（armeabi-v7a）",
          hint: "适合较老的 32 位安卓设备",
        },
      },
      archGuide: {
        title: "版本说明",
        arm64: "arm64-v8a：适用于大多数近年的安卓手机、平板、电视盒子和智能电视。",
        armeabi: "armeabi-v7a：适用于部分较老的 32 位安卓设备。",
        apk: "APK：直接安装包，下载后可在设备上直接安装。",
        zip: "备用 ZIP：如果浏览器或系统拦截 APK 下载，可下载 ZIP 后在手机或电视上先解压，再安装里面的 APK。",
      },
      desc: {
        title: "使用说明",
        section1Title: "基本功能",
        section1Body:
          "1. 应用界面右上角的购买按钮可用于账号充值。\n2. 点击刷新按钮可获取最新线路列表。\n3. 点击分享按钮可将线路共享到局域网设备。\n4. 点击对话按钮可联系微信客服。\n\n分流模式对应不同的分流策略：\n1. 智能分流：按国内与国外网站分流，仅国外网站通过线路访问。\n2. 全局模式：所有流量都通过线路访问，可能影响国内应用体验。",
        section2Title: "选择线路",
        section2Body:
          "请根据你的网络环境与使用需求选择线路。右侧绿色标签会标注适合的运营商与线路类型。\n选择线路后，再点击上图中的【连接】按钮，即可通过梯子Z访问互联网。",
      },
      usage: {
        title: "使用说明",
        step1: "下载并安装应用（APK 或应用商店）",
        step2: "打开应用并登录账号",
        step3: "选择节点并连接",
        step4: "开始使用服务",
      },
    },
    windows: {
      softwareName: "Windows 客户端名称占位",
      supportedDevices: "适用设备: Windows 7 x64, Windwos 10/11+",
      version: "当前版本: v1.0.0",
      currentVersionLabel: "当前版本",
      downloadInstaller: "下载安装包",
      downloadPortable: "解压缩版",
      desc: {
        title: "使用说明",
        section1Title: "安装梯子Z应用",
        section1Body:
          "运行下载的安装文件。若遇到安全提示，请点击“更多信息”，再点击“仍要运行”，完成安装。",
        section2Title: "基本操作",
        section2Body:
          "右上角功能区：\n1. 购物车按钮：可为梯子Z账号续费。\n2. 刷新按钮：获取最新线路列表。\n3. 分享按钮：可将线路共享到局域网。\n4. 微信按钮：添加微信客服。",
        section2RoutingTitle: "分流模式说明",
        section2RoutingBody:
          "1. 智能分流：按国内与国外网站分流，仅国外网站通过线路访问。\n2. 全局模式：所有流量都通过线路访问，可能影响国内应用体验。",
        section3Title: "选择线路",
        section3Body:
          "请根据你的网络环境与使用需求选择线路。右侧绿色标签会标注适合的运营商与线路类型。\n选择线路后，再点击上图中的【连接】按钮，即可通过梯子Z访问互联网。",
      },
      usage: {
        title: "使用说明",
        step1: "下载并安装客户端",
        step2: "打开客户端并登录账号",
        step3: "选择节点并连接",
        step4: "开始使用服务",
      },
    },
    macos: {
      softwareName: "macOS 客户端名称占位",
      supportedDevices: "适用设备: Mac 桌面 / 笔记本电脑 - macOS 10.15+",
      heroSubtitle: "请选择适合你的 macOS 客户端版本",
      version: "当前版本: v1.0.0",
      advancedVersion: "App Store",
      currentVersionLabel: "当前版本",
      supportedSystem: "适用系统",
      downloadApp: "下载应用",
      installerGroup: "普通版",
      advancedGroup: "高级版",
      installerSystem: "macOS 10.15+",
      advancedSystem: "macOS 12+",
      installerHint: "代理模式，适合浏览器访问",
      advancedHint: "VPN 模式，适合所有应用",
      choiceDivider: "或",
      downloadInstaller: "下载安装版",
      downloadAdvanced: "高级版",
      getSharedAppleId: "获取共享 Apple ID",
      backupDownload: "备用下载",
      usage: {
        title: "使用说明",
        step1: "下载并安装客户端",
        step2: "打开客户端并登录账号",
        step3: "选择节点并连接",
        step4: "开始使用服务",
      },
      versionGuide: {
        title: "普通版与高级版区别",
        standardTitle: "普通版：",
        standardBody: "采用代理模式，主要代理浏览器和跟随系统代理的应用。",
        advancedTitle: "高级版：",
        advancedBody:
          "采用 VPN 模式，可作用于系统全部应用，包括 AI 桌面应用、CLI 工具、开发工具、游戏等各类场景。",
        appleIdHint:
          "高级版需要从 App Store 下载，通常需要海外 Apple ID；如果没有，可以点击左侧的“获取共享 Apple ID”。",
        recommendHint:
          "如果只是网页访问，先用普通版即可；如果希望整台 Mac 的应用都能使用线路，建议使用高级版。",
      },
      desc: {
        title: "macOS 客户端版本说明",
        standardTitle: "下载安装包",
        standardBody:
          "适合大多数 Mac 用户。下载 DMG 安装包后，按提示拖入应用程序文件夹，打开 ZionLadder 并登录账号即可使用。",
        advancedTitle: "高级版",
        advancedBody:
          "高级版通过 App Store 安装，需要使用海外 Apple ID 下载。你可以使用站内提供的共享 Apple ID 登录 App Store 下载，下载完成后再切回自己的 Apple ID。",
        sharedIdButton: "查看共享 Apple ID",
      },
    },
    androidTv: {
      softwareName: "ZionLadder for Android TV",
      supportedDevices: "适用设备: 安卓电视、电视盒子和部分智能投影设备",
      version: "当前版本: v1.0.0",
      currentVersionLabel: "当前版本",
      downloadApp: "下载 Android TV 应用",
      downloadApk: "下载 APK",
      downloadZip: "备用 ZIP",
      backupDownload: "备用下载",
      downloads: {
        arm64: {
          title: "64 位新版内核（arm64-v8a）",
          hint: "推荐大多数新款电视、电视盒子和智能投影使用",
        },
        armeabi: {
          title: "32 位兼容内核（armeabi-v7a）",
          hint: "适合较老的 32 位安卓电视设备",
        },
      },
      archGuide: {
        title: "版本说明",
        arm64: "arm64-v8a：适用于大多数近年的安卓电视、电视盒子和智能投影设备。",
        armeabi: "armeabi-v7a：适用于部分较老的 32 位安卓电视设备。",
        apk: "APK：直接安装包，可通过 U 盘、文件管理器或电视浏览器安装。",
        zip: "备用 ZIP：如果 APK 下载受限，可下载 ZIP 后在电视或电脑上先解压，再安装里面的 APK。",
      },
      hero: {
        title: "ZionLadder for Android TV",
        subtitle: "适用于安卓电视、电视盒子和部分智能投影设备",
      },
      usage: {
        title: "使用说明",
        step1: "下载适用于电视设备的 APK 安装包",
        step2: "通过 U 盘、浏览器或文件管理器安装到电视设备",
        step3: "打开应用并登录你的 ZionLadder 账号",
        step4: "选择合适线路并连接后，即可在电视端使用",
      },
      desc: {
        title: "Android TV 安装说明",
        section1Title: "安装方式",
        section1Body:
          "Android TV 设备通常需要手动安装 APK。可以先在电脑或手机上下载文件，再通过 U 盘、局域网传输或电视自带浏览器安装。",
        section2Title: "使用建议",
        section2Body:
          "电视端建议优先选择延迟低、带宽稳定的线路。若设备架构较老，可尝试备用安装包或 armeabi-v7a 版本。",
      },
    },
    appleTv: {
      setupButton: "查看安装方式",
      sharedIdButton: "获取共享 Apple ID",
      hero: {
        title: "ZionLadder for Apple TV",
        subtitle: "在 Apple TV 的 App Store 中安装 ZionLadder，自有客户端无需手动导入订阅",
      },
      usage: {
        title: "使用说明",
        step1: "在 Apple TV 打开 App Store",
        step2: "使用海外 Apple ID 搜索 ZionLadder 或 ZionLadderTV 并安装",
        step3: "打开 App 后登录你的 ZionLadder 账号",
        step4: "选择线路并开启连接",
      },
      desc: {
        title: "Apple TV 安装说明",
        section1Title: "安装方式",
        section1Body:
          "Apple TV 不适合通过网页下载链接安装。请直接在 Apple TV 的 App Store 中搜索 ZionLadder 或 ZionLadderTV 并安装。",
        section2Title: "Apple ID",
        section2Body:
          "如果当前 Apple ID 所在地区无法搜索到应用，可以使用共享 Apple ID 临时登录 App Store 下载。下载完成后请退出共享账号，并切回自己的 Apple ID。",
      },
    },
    linux: {
      hero: {
        title: "ZionLadder for Linux",
        subtitle: "适用于 Linux 桌面、服务器、开发机和 ARM 设备",
      },
      usage: {
        title: "使用说明",
        step1: "根据 CPU 架构下载 x86_64/amd64 或 arm64 压缩包",
        step2: "解压后进入目录，按 README 或脚本提示安装",
        step3: "登录账号或导入订阅配置",
        step4: "启动服务并按需要配置系统代理或透明代理",
      },
      desc: {
        title: "Linux 下载",
        intro: "请选择与系统 CPU 架构匹配的安装包。不确定架构时，可在终端运行 uname -m 查看。",
      },
      downloads: {
        amd64:
          "适用于大多数 Intel/AMD 64 位 Linux PC、服务器和软路由，也就是常见的 x86_64/amd64 架构。",
        arm64: "适用于 64 位 ARM Linux，包括树莓派 4/5 及常见 ARM 设备。",
      },
    },
    openwrt: {
      hero: {
        title: "ZionLadder for OpenWrt",
        subtitle: "适用于 OpenWrt 路由器与软路由设备",
      },
      usage: {
        title: "使用说明",
        step1: "确认 OpenWrt 版本和设备 CPU 架构",
        step2: "OpenWrt 25.12 及以上下载 APK 包，24.10 及以下下载 IPK 包",
        step3: "在 OpenWrt 后台或 SSH 中上传并安装软件包",
        step4: "打开 ZionLadder Web UI，登录账号并启动服务",
      },
      desc: {
        title: "OpenWrt 下载",
        intro:
          "常见设备通常优先查看 aarch64 系列；软路由常见为 x86_64。不确定架构时，请在 OpenWrt 后台或 SSH 中查看系统信息。",
      },
      sections: {
        apk: {
          title: "OpenWrt 25.12 及以上",
          subtitle: "APK 软件包",
        },
        ipk: {
          title: "OpenWrt 24.10 及以下",
          subtitle: "IPK 软件包",
        },
      },
      groups: {
        common: "常见架构",
        other: "其他架构",
      },
    },
    merlin: {
      hero: {
        title: "ZionLadder for ASUS Merlin",
        subtitle: "适用于 Merlin 固件与改版梅林路由器",
      },
      usage: {
        title: "安装方式",
        step1: "根据路由器平台、CPU 架构或支持型号下载对应离线安装包",
        step2: "在路由器终端中解压：tar -xzf zionladder-PLATFORM.tar.gz",
        step3: "进入目录执行 ./install.sh",
        step4: "启动 Web UI 后打开 http://ROUTER-IP:10888/",
      },
      desc: {
        title: "Merlin 下载",
        intro:
          "安装包已包含 ZionLadder、核心运行时、规则集、Web UI、启动脚本和 Merlin 启动钩子。请选择匹配型号的原版梅林或 KoolShare 软件中心版。",
      },
      supportedModels: "支持型号",
      originalFirmware: "原版梅林固件",
      koolshareFirmware: "KoolShare 软件中心版",
    },
    third: {
      title: "第三方应用设置",
      hero: {
        title: "第三方应用",
        apps: "仅为熟悉第三方客户端的用户提供订阅链接；我们不对任何第三方应用提供技术支持",
        subscribeButton: "订阅链接",
        usage: {
          title: "重要说明",
          stabilityWarning:
            "订阅链接模式下，线路的稳定性和可用性无法保证；如果线路突然不可用，你可能需要主动更新订阅链接。",
          shareWarning:
            "严禁分享订阅链接。只要你把订阅链接提供给其他人，你的账号随时可能被封停，且无法解封。",
          converterWarning:
            "禁止使用第三方在线订阅转换工具。在线转换会导致线路信息泄漏，泄漏线路信息的账号会被封停。",
        },
      },
      quick: {
        title: "快速配置",
        subtitle: "复制你的专属订阅地址，并选择合适客户端进行导入。",
        loading: "正在获取订阅地址...",
        inputPlaceholder: "暂无可用订阅地址",
        revealButton: "显示",
        hideButton: "隐藏",
        copyButton: "复制",
        copied: "已复制",
        hint: "订阅地址默认打码显示，点击显示后可查看完整地址。",
        fetchError: "获取订阅地址失败，请稍后重试",
        copyError: "复制失败，请手动复制",
      },
      recommendHint:
        "本页面仅提供订阅链接，适合已经熟悉第三方客户端配置方式的用户使用。我们不会在这里提供第三方应用下载或使用教程。",
      sourceTabs: {
        label: "订阅源",
        hint: "如果主用订阅失败，请尝试备用。",
        main: "主用",
        backup: "备用",
        backupMissing: "当前未配置备用订阅链接，请切回主用域名。",
      },
      buttons: {
        download: "下载",
        appStore: "App Store",
        copySub: "复制订阅",
        oneClickImport: "一键导入",
        copied: "已复制",
      },
      linkTypes: {
        subscription: "通用订阅链接",
        clash: "Clash 订阅链接",
        singbox: "Sing-box 订阅链接",
      },
      platforms: {
        windows: "Windows",
        macos: "macOS",
        android: "Android",
        ios: "iOS",
        linux: "Linux",
        router: "路由器",
      },
      platformNotes: {
        macos: "安装提示：如无法安装，请在终端内运行 sudo spctl --master-disable",
        ios: "iOS 客户端需要在 App Store 购买或下载，请使用非中国区 Apple ID",
      },
      apps: {
        clashVerge: "功能强大的图形化客户端（推荐）",
        clashVergeMacTips: "如订阅报错请更新到最新版客户端；继续报错请关闭现有代理",
        clashParty: "如订阅报错请更新到最新版客户端",
        v2rayn: "轻量级 V2Ray 客户端",
        v2raynMac: "如运行提示文件损坏，请在终端运行：xattr -cr /Applications/v2rayN.app",
        v2rayu: "如弹出显示无法打开联系开发者，请在终端运行：sudo spctl --master-disable",
        nekoray: "支持多种协议的桌面客户端",
        singbox: "通用代理平台，支持最新协议",
        clashNyanpasu: "增强版 Clash 客户端",
        flclash: "Flutter 开发的现代化客户端",
        clashmi: "基于 Mihomo 内核的新客户端",
        clashmiFreeIos: "免费的 iOS Clash 客户端，使用 Clash 订阅",
        hiddify: "易用的多协议客户端",
        sfm: "sing-box 官方 macOS 客户端",
        sfa: "sing-box 官方 Android 客户端",
        sfi: "sing-box 官方 iOS 客户端",
        cmfa: "Android 平台 Clash 客户端",
        cmfaTips: "如更新订阅报 EOF 错误，请断开该配置文件连接后再更新订阅",
        v2rayng: "Android 平台 V2Ray 客户端",
        nekobox: "支持多协议的 Android 客户端",
        shadowrocket: "专业 iOS 客户端（需在 App Store 购买）",
        shadowrocketTips: "如订阅失败或测速全红，请更新到最新版 Shadowrocket",
        stash: "功能丰富的 iOS 客户端",
        loon: "支持规则分流的 iOS 客户端",
        loonTips: "Loon 订阅时请在设置界面打开解析器开关",
        quantumultx: "请更新到最新版 QX，并打开资源解析器（版本不低于 1.5.5）",
        v2raya: "Web 界面的 V2Ray 客户端",
        qv2ray: "Qt 跨平台客户端",
        openclash: "OpenWrt 路由器 Clash 插件",
        openclashTips: "如出现 GEOsite 报错，请切换 GEO 库到 FULL 版本",
        passwall: "OpenWrt 路由器多协议代理插件",
        passwallTips: "如出现报错请使用下方 Passwall2",
        passwall2: "出现报错请更新到最新版",
        ssrplus: "必须更新到最新版插件，老版本不识别 VLESS 协议",
        merlin: "梅林固件常用代理插件方案",
        merlin2: "GeoIP/GeoSite 均切换至 FULL 版本后使用",
      },
    },
  },
  manageAccount: {
    invalidLink: "无效的账户链接",
    topupFor: "你正在为以下用户充值：",
    username: "用户名",
    currentExpire: "当前有效期",
    loading: "查询中...",
    notActivated: "未充值过",
  },
  auth: {
    signInTitle: "登录",
    signUpTitle: "注册账号",
    emailLabel: "邮箱",
    passwordLabel: "密码",
    confirmPasswordLabel: "确认密码",
    rememberMe: "记住登录状态",
    signInButton: "登录",
    signInButtonLoading: "登录中…",
    signUpButton: "注册",
    signUpButtonLoading: "注册中…",
    missingCredentials: "请输入邮箱和密码",
    missingSignupFields: "请输入邮箱、密码和确认密码",
    passwordMismatch: "两次输入的密码不一致",
    noAccount: "还没有账号？",
    signUpLink: "注册新账号",
    alreadyHaveAccount: "已有账号？",
    goToSignInLink: "转到登录页面",
    emailExists: "该邮箱已注册",
    signupUnknownError: "注册失败，请稍后重试",
  },
};

export default zhCN;
